var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var Send = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 20 20" }),
        React.createElement("path", { d: "M19.61,0.35 C19.4509626,0.250441591 19.2490374,0.250441591 19.09,0.35 L0.46,9.53 C0.285522259,9.62006182 0.179908045,9.80390878 0.19,10 C0.179484093,10.1830937 0.272091544,10.3567326 0.43,10.45 L7.35,14.65 L7.35,19.29 C7.3502832,19.459996 7.43691993,19.6182022 7.58,19.71 C7.66171651,19.7592295 7.75465494,19.7867668 7.85,19.79 C7.92586686,19.78764 8.00056564,19.770663 8.07,19.74 L12.14,17.74 C12.1955923,17.711642 12.2462436,17.6744978 12.29,17.63 L15.68,19.69 C15.7576076,19.7401832 15.8476054,19.7678748 15.94,19.77 C16.0126518,19.7676374 16.0840788,19.750631 16.15,19.72 C16.296894,19.6533958 16.4016037,19.518769 16.43,19.36 L19.81,0.84 C19.8399301,0.652149782 19.7628299,0.463254275 19.61,0.35 Z M17.52,2.2 L7.74,13.68 L1.72,10 L17.52,2.2 Z M8.35,18.45 L8.35,15.22 L11.35,17.02 L8.35,18.45 Z M15.58,18.45 L8.58,14.22 L18.46,2.64 L15.58,18.45 Z" })));
};
export default Send;
